// extracted by mini-css-extract-plugin
module.exports = {"KlarnaLabel":"styles_KlarnaLabel__dTt1_","image":"styles_image__DdWZM"};